import React from "react";
import { PortWidget } from "@projectstorm/react-diagrams";
import { AbstractFactory } from "@projectstorm/react-canvas-core";
import ComponentPortModel from "./ComponentPortModel";

export default class ComponentPortFactory extends AbstractFactory {
  constructor() {
    super("component-port");
  }

  generateModel() {
    return new ComponentPortModel({ engine: this.engine });
  }

  generateReactWidget(event) {
    return <PortWidget link={event.model} diagramEngine={this.engine} />;
  }
}
